import axios from 'axios'

export const getPaymentList = () => {
  return axios.get('shipment/payment/list/1/1000')
    .then(res => res)
    .catch(err => {
      throw err.response
    })
}

export const getPaymentListFilter = (type) => {
  return axios.get(`payment/filter/unpaid/${type}/1/1000`)
    .then(res => res)
    .catch(err => {
      throw err.response
    })
}

export const getPaymentWaitingList = () => {
  return axios.get('payment/waiting/full/1/1000')
    .then(res => res)
    .catch(err => {
      throw err.response
    })
}

export const getPartialPaymentList = () => {
  return axios.get('payment/waiting/partial/1/1000')
    .then(res => res)
    .catch(err => {
      throw err.response
    })
}

export const getPaymentCompleteList = () => {
  return axios.get('payment/complete/1/1000')
    .then(res => res)
    .catch(err => {
      throw err.response
    })
}

export const downloadInvoice = ({idShipment, orderNumber, idInvoice, fileName}) => {
  return axios.get(`shipment/invoice/${idShipment}/${orderNumber}/${idInvoice}`, {responseType: 'blob'})
    .then(res => {
      let blob = new Blob([res.data], {type: res.headers['content-type']})
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      return res
    })
    .catch(err => {
      throw err.response
    })
}

export const getInvoiceDetail = (idInvoice, type) => {
  return axios.get(`payment/invoice/${idInvoice}/${type}`)
    .then(res => res)
    .catch(err => {
      throw err.response
    })
}

export const getPaymentDetail = (id) => {
  return axios.get(`payment/detail/${id}`, id)
    .then(res => res)
    .catch(err => {
      throw err.response
    })
}

export const createPayment = (data) => {
  return axios.post('payment/create', data)
    .then(res => res)
    .catch(err => {
      throw err.response
    })
}

export const getPaymentHistory = (id) => {
  return axios.get(`payment/history/${id}`, id)
    .then(res => res)
    .catch(err => {
      throw err.response
    })
}

export const downloadProof = (payload) => {
  return axios.get(`file/payment/proof/${payload.id}`, {responseType: 'blob'})
    .then(res => {
      let blob = new Blob([res.data], {type: res.headers['content-type']})
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = payload.fileName
      document.body.appendChild(link)
      link.click()
      return res
    })
    .catch(err => {
      throw err.response
    })
}

export const putProofPaymnet = (form) => axios.put('payment/', form, {
  headers: {
    'Content-Type': 'multipart/form-data'
  }
})
  .then(res => res)
  .catch((err) => {
    console.log('err', err)
    throw err.response
  })



// WEBPACK FOOTER //
// ./src/api/payment.api.js